// extracted by mini-css-extract-plugin
export default {"row":"style_row__dIeny","board":"style_board__8Ovr9"};